import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { SelectDateRange_CheckIn } from './SelectDateRange_CheckIn';

export function SelectRoom(props) {

    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [startDate, setStartDate] = useState(null);
    let [endDate, setEndDate] = useState(null);
    const [numOfNights, setNumOfNights] = useState(null);

    let [ bookingType, setBookingType ] = useState('online');
    let [ roomSalePrice, setRoomSalePrice ] = useState(null);

    useEffect(() => {

        //alert('In Select Room useEffect');
        //alert(startDate);

            let requestOptions;

            if(props.selectRoomTracker == '74701R' && (props.startDate != null && props.endDate != null))
            {
                requestOptions = {
                    method: 'POST',
                    //credentials: 'include',
                    headers: {'content-type': 'application/json' },
                    body: JSON.stringify({
                        Tracker: props.tracker,
                        user: acctID,
                        xStartDateRange: props.startDate,
                        xEndDateRange: props.endDate,
                        sessionID: sessionID,
        
                    }),
                }
            }
            else if(startDate != null && endDate != null)
            {

                // alert('IN USE EFFECT ');
                // alert(startDate);
                // alert(endDate);

                requestOptions = {
                    method: 'POST',
                    //credentials: 'include',
                    headers: {'content-type': 'application/json' },
                    body: JSON.stringify({
                        Tracker: props.tracker,
                        user: acctID,
                        xStartDateRange: startDate,
                        xEndDateRange: endDate,
                        sessionID: sessionID,
        
                    }),
                }
            }
            
            fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {
            
                            let rows = res.toString().split('~~~');
    
                            let rowLength = rows.length;

                            document.getElementById('searchAvailableRooms').innerHTML = '<option value = "0"> None </option>';

    
                                for (let rownum = 0; rownum < rowLength - 1; ++rownum)
                                {
                                    let cols = rows[rownum].split('|');

                                    //alert('in Select Room .then');
                                    //alert(cols[0]);
                                    //alert(cols[8]);

                                    document.getElementById('searchAvailableRooms').insertAdjacentHTML('beforeend', '<option class=\'forRemoveProjectSearch\' data-id=\''+cols[0]+'\' data-cost=\''+cols[8]+'\' >'+cols[0]+'</option>');
    
                                }
                                
                        }, 'html')
        
    }, [startDate, endDate]);

    async function getRoomsSalePrice(event)
    {
        /*let formData = new FormData();
        formData.append('Tracker', '74100_SP');
        formData.append('user', acctID);
        formData.append('xCheckInRoomID', event);
    
        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            //credentials: 'include',
            files: formData,
            body: formData,
            contentType: false,
            processData: false,
        }*/


        const requestOptions = {
            //enctype: 'multipart/form-data',
            method:'POST',
            //credentials: 'include',
            headers: {'content-type': 'application/json' },
            //files: formData,
            body: JSON.stringify({
                Tracker: '74100_SP',
                user: acctID,
                xCheckInRoomID: event,
                sessionID: sessionID,

            }),
        }

        await fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            let cols = res.toString().split('|');

            //setSelectedValue_cost_state(cols);
            //alert(cols.toString());

            //return res.toString();
            props.onCheckInRoomID_multiple({selectedRoomID: event, selectedBookingType: bookingType, selectedRoomSalesPrice: cols});

        })
    }

    function availableRoomDetails()
    {

        //alert("In AvailableRoomDetails");
        //alert(document.getElementById("searchAvailableRooms").selectedOptions);


        //let selectBox = document.getElementById("searchAvailableRooms");
        let selectBox = document.getElementById("searchAvailableRooms").selectedOptions;
        var numOfOptions = Array.from(selectBox).map(({ value }) => value);

        if(numOfOptions.length == 1)
        {
            let selectedValue_id = numOfOptions[0];
            let selectedValue_cost = 0.00;

            if(selectedValue_id == 2)
            {
                selectedValue_cost = 200.00;
            }
            else if(selectedValue_id == 1 || selectedValue_id == 3 || selectedValue_id == 8 || selectedValue_id == 10 || selectedValue_id == 13)
            {
                selectedValue_cost = 250.00;
            }
            else if(selectedValue_id == 7 || selectedValue_id == 9 || selectedValue_id == 11 || selectedValue_id == 17 || selectedValue_id == 18)
            {
                selectedValue_cost = 350.00;
            }
            else if(selectedValue_id == 101)
            {
                selectedValue_cost = 2000.00;
            }
            else
            {
                selectedValue_cost = 300.00;
            }

            setRoomSalePrice(selectedValue_cost);
            props.onCheckInRoomID({selectedRoomID: selectedValue_id, selectedBookingType: bookingType, selectedRoomSalesPrice: selectedValue_cost});

        }
        else if(numOfOptions.length > 1)
        {
            let selectedValue_id = [];
            let selectedValue_cost = [];

            for (let optionNum = 0; optionNum < numOfOptions.length; ++optionNum)
            {
                selectedValue_id.push(numOfOptions[optionNum]);

                //selectedValue_cost.push(getRoomSalePrice(numOfOptions[optionNum]));

                //selectedValue_cost.push(numOfOptions[optionNum].getAttribute('data-cost'));

            }

            getRoomsSalePrice(selectedValue_id);

            //setSelectedValue_id_state(selectedValue_id);
            setRoomSalePrice('Multiple');
            //props.onCheckInRoomID_multiple({selectedRoomID: selectedValue_id, selectedBookingType: bookingType, selectedRoomSalesPrice: selectedValue_cost});
        }

        //let selectedValue_id = selectBox.options[selectBox.selectedIndex].getAttribute('data-id');
        //let selectedValue_cost = selectBox.options[selectBox.selectedIndex].getAttribute('data-cost');

        //setRoomSalePrice(selectedValue_cost);
        //props.onCheckInRoomID({selectedRoomID: selectedValue_id, selectedBookingType: bookingType, selectedRoomSalesPrice: selectedValue_cost});

    }

    /*function closeModalHandler() {

        setViewInventoryBookedRooms([]);
        props.closeModal(false);
    }*/

    function onCheckInDateHandler(event) {

        // alert("ON CHECK IN DATE HANDLER");
        // alert(event.startDate);
        // alert(event.endDate);

        setStartDate(event.startDate);
        setEndDate(event.endDate);
        setNumOfNights(event.numOfNights);

        props.onCheckInDate(event);
    
    }

    function bookingTypeHandler(e)
    {
        e.persist(); 
        let event = e.target.value; 

        setBookingType(event);
    
    }

    return (

        <React.Fragment>
            {props.openModal == true && props.selectRoomTracker == '74701B' &&
            (
                    <React.Fragment>

                            <SelectDateRange_CheckIn onCheckInDate={onCheckInDateHandler}></SelectDateRange_CheckIn>

                            <IonRow>
                                <IonCol> Booking Type</IonCol>
                                <IonCol> Room ID</IonCol>
                                <IonCol> Price Per Night</IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol> 
                                    <select id='setBookingType' onChange={(e) => bookingTypeHandler(e)} multiple>
                                        <option value='online'> Online </option>
                                        <option value='phone' selected='selected'> Phone </option>
                                        <option value='in_person'> In-Person </option>
                                    </select>
                                </IonCol>
                                <IonCol> 
                                    <select id='searchAvailableRooms' onChange={() => availableRoomDetails()} multiple>
                                    </select>
                                </IonCol>
                                <IonCol> {roomSalePrice} </IonCol>
                            </IonRow>
                    </React.Fragment>

            ) 
            }

            {props.openModal == true && props.selectRoomTracker == '74701R' &&
                (
                    <React.Fragment>
                        <select id='searchAvailableRooms' onChange={availableRoomDetails} multiple>
                            <option value='0'> None </option>
                        </select>
                    </React.Fragment>

                ) 
            }
            
        </React.Fragment>
    )
}